// extracted by mini-css-extract-plugin
export default {"section":"section__FaWzo","reducePadding":"reducePadding__c9sAQ","bolderTitle":"bolderTitle__26tQs"};